module.exports = __webpack_public_path__ + "img/no_data.02e3f52d.png";